import { ITEM } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IModifyProjectItemValuesRequest extends IBaseRequest {
    projectId: number;
    billingStatus?: string;
    method: string;
    value: string;
}

export class ModifyProjectItemValuesRequest extends BaseRequest implements IModifyProjectItemValuesRequest {
    public projectId: number;
    public billingStatus?: string;
    public method: string;
    public value: string;
  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.projectId = otherOptions.projectId;
    this.billingStatus = otherOptions.billingStatus;
    this.method = otherOptions.method;
    this.value = otherOptions.value;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.projectId, 'projectId');
    parameters += this.makeNode(this.billingStatus, 'billingStatus');
    parameters += this.makeNode(this.method, 'method');
    parameters += this.makeNode(this.value, 'value');

    return super.wrapperXml(ITEM.modifyProjectItemValues, parameters);
  }
}
